<template>
  <div style="height: 100%;">
<!--    <a-input-search style="margin-bottom: 8px" placeholder="Search" @change="onChange" />-->
    <div style="height: 100%;overflow-y: auto">
      <a-tree
          v-if="treeData.length>0"
          :tree-data="treeData"
          :defaultExpandAll="true"
          :defaultSelectedKeys="['00-00']"
          :replaceFields="{children:'children', title: 'name', key: 'code'}"
          @select="selectTree"
          :selectedKeys.sync="selectedKeys"
          :expandKeys="expandKeys"
      />
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      selectedKeys: []
    }
  },  
  props: {
    treeData: {
      type: Array,
      default: ()=>{
        return []
      }
    },
    expandKeys: {
      type: Array,
      default: ()=>{
        return []
      }
    },
    customerInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  methods: {
    selectTree(value, row) {
      if (value.length === 0) {
        return
      }
      if (value[0] === 'un-00') {
        this.$emit('getTreeData', { data:treeData[0]})
      } else {
        this.$emit('getTreeData', {data: row.node.dataRef})
      }
    },
  },
  watch: {
    customerInfo: {
      deep: true,
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.selectedKeys = [newVal.value + '']
          this.$emit('getTreeData', { data:{name: newVal.text, code: newVal.value, level: 3}})
        }
      }
    }
  },
  
}
</script>

<style lang="less" scoped>
/deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  width: 100%;
  background-color: #fff1b8;
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
}
</style>
